import React, { useEffect, useState } from "react";
import socket from "../../assets/socketConnection";
import MessageList from "../../components/messageList/messageList.component";
import WithSpinner from "../../HOC/withSpinner/WithSpinner.component";
const MessageWithSpinner = WithSpinner(MessageList);
const Messages = () => {
  const [msgData, setMsgData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    socket.emit("get_my_messages", {});
    socket.on("response_my_messages", (messages) => {
      setMsgData(messages);
      setIsLoading(false);
    });
    socket.emit("seen_all_messages", {});
  }, []);
  return (
      <MessageWithSpinner
        isLoading={isLoading}
        msgData={msgData}
        setMsgData={setMsgData}
      ></MessageWithSpinner>
  );
};

export default Messages;
